import { useNavigate, Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useAutoFocus } from "@/hooks/useAutoFocus";

/**
 * Privacy e Cookie — descrizione tecnica del comportamento dell'app (P1-9).
 * NON è consulenza legale. PostHog e Google Fonts sono già stati rimossi (FASE 1).
 * I cookie tecnici della piattaforma di hosting sono descritti in modo fattuale.
 */
export default function Privacy() {
  const navigate = useNavigate();
  const headingRef = useAutoFocus();

  return (
    <main className="screen" data-testid="privacy-screen">
      <div className="screen__header">
        <button
          type="button"
          className="back-btn"
          data-testid="privacy-back-button"
          onClick={() => navigate("/")}
          aria-label="Torna alla schermata principale"
        >
          <ChevronLeft size={16} strokeWidth={2.5} aria-hidden="true" />
          Indietro
        </button>
        <h1 className="screen__title" tabIndex={-1} ref={headingRef}>
          Privacy e Cookie
        </h1>
      </div>

      <p className="doc__p" data-testid="privacy-updated">Ultimo aggiornamento: giugno 2026.</p>

      <h2 className="section-label">Dati raccolti dall'app</h2>
      <p className="doc__p">
        FOCUSTAP <strong>non richiede registrazione né account</strong> e non raccoglie dati personali.
        Le uniche informazioni salvate restano <strong>sul tuo dispositivo</strong> (nella memoria
        locale del browser): il record personale, il numero di partite giocate e la preferenza della
        modalità Accessibilità. Non vengono inviate ad alcun server e puoi eliminarle cancellando i
        dati del browser per questo sito.
      </p>

      <h2 className="section-label">Classifica online</h2>
      <p className="doc__p" data-testid="privacy-leaderboard">
        La partecipazione alla classifica è <strong>facoltativa</strong>. Solo se scegli di entrare in
        classifica creando un nickname, vengono salvati su un server i seguenti dati:
      </p>
      <ul className="doc__list">
        <li className="doc__li">
          il <strong>nickname</strong> che scegli, usato come identificativo pseudonimo pubblico;
        </li>
        <li className="doc__li">
          il tuo <strong>record personale</strong> (punteggio) associato al nickname;
        </li>
        <li className="doc__li">
          i <strong>dati tecnici</strong> strettamente necessari al funzionamento e alla sicurezza
          della classifica (ad esempio un identificativo anonimo del dispositivo e informazioni di
          sessione per prevenire abusi).
        </li>
      </ul>
      <p className="doc__p">
        Per partecipare <strong>non</strong> vengono richiesti email, password o account Google. Il
        nickname è permanente e non modificabile. Se non crei un nickname, nessun dato di gioco lascia
        il tuo dispositivo.
      </p>

      <h2 className="section-label">Analytics e tracciamento</h2>
      <p className="doc__p">
        L'app <strong>non utilizza strumenti di analytics né di tracciamento</strong>: nessuna
        registrazione delle sessioni, nessun profilo utente e nessun caricamento di font esterni.
      </p>

      <h2 className="section-label">Cookie tecnici della piattaforma</h2>
      <p className="doc__p">
        Il sito è pubblicato tramite la piattaforma di hosting <strong>Emergent</strong>.
        L'infrastruttura di hosting può impostare cookie tecnici di prima parte (ad esempio
        <code> __emg_vid</code> e <code> __emg_sid</code>) e caricare uno script di piattaforma
        (<code>emergent-main.js</code>). Questi elementi sono gestiti dalla piattaforma di hosting e
        non dall'app. Per informazioni su finalità, durata e gestione, è possibile contattare il
        supporto della piattaforma.
      </p>

      <h2 className="section-label">Condivisione con terze parti</h2>
      <p className="doc__p">
        L'app di per sé non condivide dati con terze parti. Eventuali trattamenti legati
        all'infrastruttura di hosting sono di competenza della piattaforma.
      </p>

      <h2 className="section-label">Contatti e note</h2>
      <p className="doc__p">
        Per domande relative al gioco puoi consultare le pagine{" "}
        <Link to="/info" className="doc__link" data-testid="privacy-info-link">
          Info
        </Link>{" "}
        e{" "}
        <Link to="/come-si-gioca" className="doc__link" data-testid="privacy-how-to-play-link">
          Come si gioca
        </Link>
        . Questo testo descrive il comportamento tecnico dell'app e{" "}
        <strong>non costituisce consulenza legale</strong>.
      </p>
    </main>
  );
}
